import { DockPanel, useDock } from '@hana/shell';
import { Alerts, Notis, Sec, type DockNoti } from './crmDock';
import { NO_CONTRACT, dupCounts, quickCount, type QuickKey } from './contractListData';
import type { Contract } from './types';
import { useT } from '@hana/i18n';
import './i18n';

// Bảng phải của Mint-Contract (khổ 1920 mở sẵn): Cảnh báo · Hoạt động · Thông báo. Số cảnh báo tính từ danh sách; Hoạt động / Thông báo là mẫu của board.
type K = 'alert' | 'act' | 'noti';
const ACTS: DockNoti[] = [
  { text: 'crm.ct.dk.a0', when: 'crm.ct.dk.a0w', tone: 'gray' },
  { text: 'crm.ct.dk.a1', when: 'crm.ct.dk.a1w', tone: 'blue' },
  { text: 'crm.ct.dk.a2', when: 'crm.ct.dk.a2w', tone: 'gray' },
  { text: 'crm.ct.dk.a3', when: 'crm.ct.dk.a3w', tone: 'amber' },
];
const NOTIS: DockNoti[] = [
  { text: 'crm.ct.dk.n0', when: 'crm.ct.dk.n0w', tone: 'red', unread: true },
  { text: 'crm.ct.dk.n1', when: 'crm.ct.dk.n1w', tone: 'amber', unread: true },
];

export function useContractDock() {
  return useDock<K>('alert');
}

export function ContractDock({ rows, dock, onFilter }: { rows: readonly Contract[]; dock: ReturnType<typeof useContractDock>; onFilter: (k: QuickKey) => void }) {
  const t = useT();
  if (!dock.open) return null;
  const tr = (xs: DockNoti[]) => xs.map((x) => ({ ...x, text: t(x.text), when: t(x.when) }));
  const dupN = Object.values(dupCounts(rows)).filter((v) => v > 1).length;
  const alerts = [
    { n: quickCount('e30', rows), k: t('crm.ct.dk.l0'), d: t('crm.ct.dk.d0'), tone: 'err' as const, go: () => onFilter('e30') },
    { n: quickCount('ap', rows), k: t('crm.ct.dk.l1'), d: t('crm.ct.dk.d1'), tone: 'warn' as const, go: () => onFilter('ap') },
    { n: NO_CONTRACT.length, k: t('crm.ct.dk.l2'), d: t('crm.ct.dk.d2'), tone: 'err' as const, go: () => onFilter('noc') },
    { n: dupN, k: t('crm.ct.dk.l3'), d: t('crm.ct.dk.d3'), tone: 'warn' as const, go: () => onFilter('dup') },
  ];
  const tabs = [
    { key: 'alert' as const, label: t('crm.ct.dk.l4') },
    { key: 'act' as const, label: t('crm.ct.dk.l5') },
    { key: 'noti' as const, label: t('crm.ct.dk.l6') },
  ];
  return (
    <DockPanel tabs={tabs} tab={dock.tab} onTab={dock.show} onClose={dock.close} closeLabel={t('crm.ct.dk.l7')}>
      {dock.tab === 'alert' && (
        <>
          <Alerts items={alerts} />
          <Sec title={t('crm.at.1')}>{null}</Sec>
        </>
      )}
      {dock.tab === 'act' && <Notis items={tr(ACTS)} />}
      {dock.tab === 'noti' && <Notis items={tr(NOTIS)} />}
    </DockPanel>
  );
}
